import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { toast } from 'react-toastify';
import { ConstructionForm } from '~/components/common/constructions/ConstructionForm';
import type { DealConstructionEdit } from '~/models/DealConstruction';
import {
  buildDefaultConstruction,
  validationSchemaConstruction
} from '~/models/DealConstruction';
import type { NskResponse } from '~/models/Api';
import { ConstructionFormFooter } from '../ConstructionFormFooter';
import { isSuccess } from '~/utils/api/api_handler';
import type { DealConstructionItem } from '~/models/DealConstructionItem';

type Props = {
  dealConstructionItems: DealConstructionItem[];
  handleCreate: (
    submitValue: DealConstructionEdit
  ) => Promise<NskResponse<void>>;
  mutateConstructions: () => Promise<void>;
  disabled?: boolean;
};
export const ConstructionAddForm: React.FC<Props> = ({
  dealConstructionItems,
  handleCreate,
  mutateConstructions,
  disabled = false
}: Props) => {
  const methods = useForm<DealConstructionEdit>({
    defaultValues: buildDefaultConstruction('add'),
    mode: 'onBlur',
    resolver: yupResolver(validationSchemaConstruction)
  });
  const onClickSubmit = React.useCallback(() => {
    if (handleCreate === null) return;
    methods.handleSubmit(async () => {
      const response = await handleCreate(methods.getValues());
      if (isSuccess(response)) {
        await mutateConstructions();
        methods.reset();
        toast.success('追加しました');
        return;
      }
      toast.error('エラーが発生しました');
      methods.reset();
    })();
  }, [handleCreate, methods, mutateConstructions]);
  return (
    <FormProvider {...methods}>
      <ConstructionForm
        dealConstructionItems={dealConstructionItems}
        disabled={disabled}
      />
      <ConstructionFormFooter
        disabled={disabled || methods.formState.isSubmitting}
        onClickSubmit={onClickSubmit}
        type="add"
      />
    </FormProvider>
  );
};
